module.exports = __webpack_public_path__ + "img/banner_1.4054ba7e.webp";